import Prism from "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import "./ReadOnlyCodeBlock.css"


// Load the languages you actually use:
import "prismjs/components/prism-javascript";
import "prismjs/components/prism-c";
import "prismjs/components/prism-cpp";
import "prismjs/components/prism-python";
import "prismjs/components/prism-java";
import "prismjs/components/prism-scala";
import "prismjs/components/prism-bash";
import "prismjs/components/prism-rust";
import "prismjs/components/prism-nasm";
import "prismjs/components/prism-verilog";
import "prism-themes/themes/prism-vsc-dark-plus.css";

import { useEffect, useRef, useMemo, useState } from "react";

// Prism.manual = true;

export default function ReadOnlyCodeBlock({ code = "", language = "JavaScript" }) {
  const codeRef = useRef(null);
  const [tooltipVisible, setTooltipVisible] = useState(false);

  const prismLangMap = useMemo(() => ({
    "C++":        "cpp",
    "C":          "c",
    "Java":       "java",
    "Python":     "python",
    "Scala":      "scala",
    "JavaScript": "javascript",
    "Bash":       "bash",
    "Rust":       "rust",
    "x86":        "nasm",    
    "Verilog":    "verilog",
  }), []);

  const lang = prismLangMap[language] || "javascript";

  useEffect(() => {
    if (codeRef.current) {
      Prism.highlightElement(codeRef.current);
    }
  }, [code, lang]); // re-run when language changes too



  return (

    <>
        <div className="attempts-outer-wrapper">
            <pre className="submission-code-block-wrapper" >
                <code ref={codeRef} className={`language-${lang}`}
                    style={{
                        width: "85%",
                        overflowWrap: "break-word",
                        whiteSpace: "pre-wrap",
                        backgroundColor: "#1e1e1e"
                    }}
                >
                    {code}
                </code>
            </pre>
            <div className="code-spacing-div" />
        </div>
    </>




  );
}
